import { toast } from "react-toastify";
import { ToastCloseButton } from "./ToastCloseButton";
import { theme } from "@utilities";

interface ToastMessage {
    Message: string;
}

export const ErrorToast = ({ Message }: ToastMessage) => {
    // eslint-disable-next-line no-console
    console.error(Message);
    toast.error(Message, {
        toastId: Message,
        className: "toastError",
        closeButton: ToastCloseButton,
        icon: () => <img src="/images/toast/Error.svg" />,
        progressStyle: { background: theme.colors.toast_error },
    });
};
